import { render, staticRenderFns } from "./PricingColumn.vue?vue&type=template&id=8f60d318&scoped=true&"
import script from "./PricingColumn.vue?vue&type=script&lang=ts&"
export * from "./PricingColumn.vue?vue&type=script&lang=ts&"
import style0 from "./PricingColumn.vue?vue&type=style&index=0&id=8f60d318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f60d318",
  null
  
)

export default component.exports